/* Candywrap v2 header: menu op desktop opent pas bij klikken (smal paneel onder het item) en sluit bij klikken ernaast of Esc. */
(function () {
  var mq = window.matchMedia('(min-width: 769px)');
  function init() {
    var menu = document.querySelector('store-header main-menu');
    if (!menu || menu.__cw) return; menu.__cw = true;
    var sel = '.main-nav > li > details';
    /* hover mag het menu niet meer openen of sluiten */
    menu.addEventListener('mouseenter', function (e) { if (mq.matches && e.target.closest && e.target.closest('.main-nav')) e.stopPropagation(); }, true);
    document.addEventListener('mouseenter', function (e) { if (mq.matches && e.target.matches && e.target.matches('.js-overlay, .js-closes-menu')) e.stopPropagation(); }, true);
    function setOpen(d, on) {
      d.classList.toggle('is-open', on);
      if (on) d.setAttribute('open', ''); else d.removeAttribute('open');
      var s = d.querySelector(':scope > summary'); if (s) s.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function closeAll(except) { menu.querySelectorAll(sel + '.is-open').forEach(function (d) { if (d !== except) setOpen(d, false); }); }
    menu.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var sum = e.target.closest(sel + ' > summary');
      if (!sum) return;
      e.preventDefault(); e.stopPropagation();
      var d = sum.parentElement, isOpen = d.classList.contains('is-open');
      closeAll(d); setOpen(d, !isOpen);
    }, true);
    document.addEventListener('click', function (e) { if (mq.matches && !e.target.closest(sel)) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    /* bij openen geen hele-pagina overlay */
    menu.querySelectorAll(sel).forEach(function (d) { setOpen(d, false); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* & in koppen vervangen door een span met Outfit */
(function () {
  function amp(root) {
    (root || document).querySelectorAll('h1, h2, h3, .dt, .pg-h, .product-title, .ch, .cw-help2__h').forEach(function (h) {
      if (h.__amp || h.textContent.indexOf('&') < 0) return; h.__amp = true;
      var w = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), n, list = [];
      while ((n = w.nextNode())) if (n.nodeValue.indexOf('&') > -1 && !(n.parentNode.classList && n.parentNode.classList.contains('cw-amp'))) list.push(n);
      list.forEach(function (t) {
        var parts = t.nodeValue.split('&'), f = document.createElement('span'); f.className = 'cw-amp-w';
        parts.forEach(function (p, i) { if (i) { var s = document.createElement('span'); s.className = 'cw-amp'; s.textContent = '&'; f.appendChild(s); } f.appendChild(document.createTextNode(p)); });
        t.parentNode.replaceChild(f, t);
      });
    });
  }
  if (document.readyState !== 'loading') amp(); else document.addEventListener('DOMContentLoaded', function () { amp(); });
})();

/* menu: items die met 'Alle' beginnen dikgedrukt */
(function () {
  function mark() { document.querySelectorAll('store-header .child-nav__item').forEach(function (a) { if (/^\s*Alle\s/i.test(a.textContent)) a.classList.add('cw-all'); }); }
  if (document.readyState !== 'loading') mark(); else document.addEventListener('DOMContentLoaded', mark);
})();
